import React from 'react';
import PropTypes from 'prop-types';
import './CreateChatGroupModal.scss'; // reuse same file or split if needed
import newcomLogo from '../TeamFeed/blocks/ActionButtons/assets/delete-icon.svg'; // replace with your actual logo path
class CreateChannelModal extends React.Component {
    state = {
        channelName: '',
        channelDescription: '',
        isCreating: false,
    };

    handleNameChange = (e) => this.setState({ channelName: e.target.value });
    handleDescriptionChange = (e) => this.setState({ channelDescription: e.target.value });

    handleCreateChannel = () => {
        const { channelName, channelDescription } = this.state;
        const { locationId, currentUserId, createChannel, onClose, onChannelCreate } = this.props;

        if (!channelName.trim() || !channelDescription.trim()) return;

        this.setState({ isCreating: true });
        createChannel(channelName, locationId, channelDescription);
        onClose();
        if (onChannelCreate) {
            onChannelCreate(); // 👈 Switch tab after starting Channel
        }
    };

    render() {
        const { onClose } = this.props;
        const { channelName, channelDescription, isCreating } = this.state;
        const isDisabled = !channelName.trim() || !channelDescription.trim() || isCreating;

        return (
            <div className="chat-modal-overlay">
                <div className="chat-modal-content">
                    <div className="chat-modal-header">
                        <h3 className="chat-modal-title">Create Group</h3>
                        {/* <button className="chat-modal-close" onClick={onClose}>×</button> */}
                    </div>
                    <div style={{ margin: '0 -24px' }}>
                        <hr className="modal-divider-full" />
                    </div>
                    {/* <img src={newcomLogo} alt="logo" className="chat-modal-logo" /> */}

                    <label className="chat-modal-label">Group Name</label>
                    <input
                        type="text"
                        value={channelName}
                        onChange={this.handleNameChange}
                        className="chat-modal-input"
                        placeholder="Enter group name"
                    />

                    <label className="chat-modal-label">Group Description</label>
                    <textarea
                        value={channelDescription}
                        onChange={this.handleDescriptionChange}
                        rows={4}
                        className="chat-modal-textarea"
                        placeholder="Enter group description"
                    />

                    <div className="chat-modal-actions">
                        <button onClick={onClose} className="chat-modal-button cancel-button">Cancel</button>
                        <button onClick={this.handleCreateChannel} className="chat-modal-button primary-button" disabled={isDisabled}>
                            {isCreating ? 'Creating...' : 'Save Changes'}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

CreateChannelModal.propTypes = {
    createChannel: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    currentUserId: PropTypes.number.isRequired,
    locationId: PropTypes.number.isRequired,
};

export default CreateChannelModal;
